import React, { Component } from 'react';
import { localsMessages } from '../utility/getTemplateData';
import { Tooltip } from '@paypalcorp/pp-react';
import { StyleSheet, css } from 'aphrodite';

const messages = localsMessages('common/ppcc');

const styles = StyleSheet.create({
  baseLayerContainer: {
    position: 'absolute',
  },

  centeringContainer: {
    position: 'absolute',
    top: -7,
    left: -2,
  },
});

export default class PPCC extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isToolTipOpen: false,
    };
  }

  render = () => {
    return (
      <span className={css(styles.baseLayerContainer)}>
        <span className={css(styles.centeringContainer)}>
          <Tooltip description={messages.ppcc.tooltip} verifiedIcon />
        </span>
      </span>
    );
  };
}
